var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0.75H8.25M12.75 0.75V5.25M12.75 0.75L7.25 6.25M5.01667 0.75C3.52333 0.75 2.77667 0.75 2.206 1.04067C1.70426 1.29633 1.29633 1.70426 1.04067 2.206C0.75 2.77667 0.75 3.52333 0.75 5.01667V8.48333C0.75 9.97667 0.75 10.7233 1.04067 11.294C1.29633 11.7957 1.70426 12.2037 2.206 12.4593C2.77667 12.75 3.52333 12.75 5.01667 12.75H8.48333C9.97667 12.75 10.7233 12.75 11.294 12.4593C11.7957 12.2037 12.2037 11.7957 12.4593 11.294C12.75 10.7233 12.75 9.97667 12.75 8.48333V7.75",
    stroke: "#FD4319",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlink);
export default __webpack_public_path__ + "static/media/Hyperlink.06a4a2b6801cc848d814cbf6e02e67dd.svg";
export { ForwardRef as ReactComponent };